module.exports = __webpack_public_path__ + "img/etc-etc-checkbox.d64f2656.svg";